module.exports = __webpack_public_path__ + "assets/people-882a69187b05a5c0b079d75508f9823b.svg";